/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */


/**
 * Enum is translated, keys must not be changed!
 */
export enum ExportFormat {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    fibuExportLexwareCsv = 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    fibuExportLexwareXml = 1,

}


/**
 * This enum is translated. Keys must not be changed
 */
export enum DistributionChannel {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    standardBrutto = 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    standardNetto = 1,
}

export enum FibuBookingType {
    BatchBooking = 0,
    Journal = 1,
    Recurring= 2,
}


/**
 * Enum is translated, keys must not be changed!
 */
export enum FBookingSplitType {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    fibuSplitDebit = 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    fibuSplitCredit = 1,
}


export enum RecurringIntervals {
    Daily = 0,
    Weekly = 1,
    Monthly = 2,
    SemiAnnual = 3,
    Annual = 4
}

/**
 * Enum is translated, keys must not be changed!
 */
export enum TypeOfProfitDetermination {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    fibuBalanceSheet = 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    fibuIncomeSurplusCalculation = 1,
}

/**
 * Enum is translated, keys must not be changed!
 */
export enum StandardFormOfAccounts {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    skr03 = 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    skr04 = 1,
}

/**
 * Enum is translated, keys must not be changed!
 */
export enum FinApiStatus {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    finApiCreated = 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    finApiPending = 1,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    finApiConnected = 2,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    finApiFailure = 3,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    finApiPaused = 4,
}

export function getFinApiStatusIcon(status: CategorizationStatus): string {
    switch (status) {
        case CategorizationStatus.fibuFinApiStatusINPROGRESS:
            return `<span class="material-symbols-outlined" style="font-size: 24px">add</span>`;
        case CategorizationStatus.fibuFinApiStatusPENDING:
            return `<span class="material-symbols-outlined" style="font-size: 24px">pending</span>`;
        case CategorizationStatus.fibuFinApiStatusREADY:
            return `<span class="material-symbols-outlined" style="font-size: 24px">preliminary</span>`;
    }
}

/**
 * Enum is translated, keys must not be changed!
 */
export enum CategorizationStatus {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    fibuFinApiStatusPENDING = 1,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    fibuFinApiStatusINPROGRESS = 2,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    fibuFinApiStatusREADY = 3
}

export enum WebFormStatus {
    NOTYETOPENED = 1,
    INPROGRESS = 2,
    COMPLETED = 3,
    COMPLETEDWITHERROR = 4,
    EXPIRED = 5,
    ABORTED = 6
}

export enum FBookingSourceType
{
    bookingSourceManual = 0,
    bookingSourceRecurring = 1,
    bookingSourceFinApi = 2,
    bookingSourceEmail = 3,
    bookingSourceLexware = 4,
    bookingSourceOcrImport=5,
}
